import React, { Component } from 'react'
import Font from '@cred/react-font'
import Link from 'components/link'
import PropTypes from 'prop-types'
import Tooltip from 'components/tooltip'
import logo from '@cred/global-assets/images/logos/credible/logo-blue.svg'
import { Disclosure } from '@cred/react-disclosures-sdk'
import config from 'config'
import styles from './styles.scss'

const getFontColor = (theme) => {
  switch (theme) {
    case 'insider':
      return 'accent'
    default:
      return 'secondary'
  }
}

class RateWidgetFooter extends Component {
  static propTypes = {
    theme: PropTypes.string,
    footerDisclosure: PropTypes.string,
    noMargin: PropTypes.bool,
    multiVertical: PropTypes.bool,
    containerClass: PropTypes.string,
  }

  static defaultProps = {
    footerDisclosure: 'partners-widgets.advertiser-disclaimer.default',
    noMargin: false,
    multiVertical: false,
  }

  render() {
    const { theme, footerDisclosure, noMargin, multiVertical, containerClass } = this.props,
      partners = ['thebalance1', 'investopedia1', 'yahoo1', 'insider'],
      hidePartners = ['thebalance1', 'investopedia1'],
      linkCss = partners.includes(theme) ? theme : '',
      linkFont = theme === 'yahoo1' ? 'yahoo1Font' : '',
      showDisclosure = !hidePartners.includes(theme),
      smallerCls = multiVertical ? 'small' : '',
      poweredByCls = multiVertical ? 'poweredBy' : '',
      reverseCls = multiVertical ? 'reverse' : ''

    const fontColor = getFontColor(theme)

    return (
      <div className={`${styles.container} ${styles[reverseCls]} ${containerClass || ''}`}>
        <div className={styles.links}>
          <Font
            type="disclaimer"
            className={`${multiVertical ? '' : 'mt-16'} ${noMargin ? '' : 'ml-md-16'} ${
              styles[linkFont]
            }`}
          >
            <Link
              type="disclaimer"
              color={fontColor}
              rel="nofollow"
              className={`${styles[linkCss]} ${styles[smallerCls]}`}
              blank
              href={`${config.credibleRoot}/terms`}
            >
              Terms
            </Link>
            {' | '}
            <Link
              type="disclaimer"
              color={fontColor}
              rel="nofollow"
              className={`${styles[linkCss]} ${styles[smallerCls]}`}
              blank
              href={`${config.credibleRoot}/privacy`}
            >
              Privacy Policy
            </Link>
            {showDisclosure && ' | '}
            {showDisclosure && (
              <Link
                type="disclaimer"
                color={fontColor}
                className={styles[linkCss]}
              >
                <Tooltip
                  analyticsOptions={{ contentSubject: 'Advertiser Disclosure' }}
                  contentProps={{ type: 'disclaimer', color: 'lighter' }}
                  triggerProps={{ type: 'disclaimer', color: fontColor }}
                  triggerContent={<span className={styles[smallerCls]}>Advertiser Disclosure</span>}
                >
                  <Font type="disclaimer" className={styles.footerDisclosure}>
                    <Disclosure required={false} slug={footerDisclosure} />
                  </Font>
                </Tooltip>
              </Link>
            )}
          </Font>
        </div>
        <div className={styles.logo}>
          <Font
            type="disclaimer"
            className={`${multiVertical ? '' : 'mt-8 mt-md-16'} ${styles[poweredByCls]}`}
          >
            Powered by{' '}
            <img alt="Credible logo" src={logo} className={`${noMargin ? '' : 'mr-md-16'}`} />
          </Font>
        </div>
      </div>
    )
  }
}

export { RateWidgetFooter }

export default RateWidgetFooter
